import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setCategory, performSearch, setPage } from './actions.mjs';

class SearchFilters extends Component {
  setCurrentCategory(id) {
    document.activeElement.blur();
    this.props.dispatch(setCategory(id));
    this.props.dispatch(setPage(1));
  }

  getTotalCount() {
    const count = this.props.results.hitCategories.all;
    return count;
  }

  getCountForCategory(id) {
    let count = _.get(this.props.results.hitCategories, id);
    if (!count) {
      count = 0;
    }
    return count;
  }

  getClasses(id) {
    if (id === this.props.currentCategory) {
      return 'search-page__filters-list-item search-page__filters-list-item--active';
    } else if (id === '' && !this.props.currentCategory) {
      // Special kludge for "all" selection
      return 'search-page__filters-list-item search-page__filters-list-item--active';
    }
    return 'search-page__filters-list-item';
  }

  render() {
    return (
      <div className="search-page__filters_container">
        <div className="search-page__filters">
          <div className="search-page__filters-title">
            {this.props.translations.filterTitle}:
          </div>
          <ul className="search-page__filters-list">
            <li className={this.getClasses('')}>
              <button
                onClick={() => this.setCurrentCategory('')}
                className="search-page__filters-list-item-button"
              >
                {this.props.translations.allTabTitle} ({this.getTotalCount()})
              </button>
            </li>
            {this.props.categories.map(category => {
              return (
                <li className={this.getClasses(category.id)} key={category.id}>
                  <button
                    onClick={() => this.setCurrentCategory(category.id)}
                    className="search-page__filters-list-item-button"
                  >
                    {category.name} ({this.getCountForCategory(category.id)})
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    query: state.query,
    translations: state.translations,
    loading: state.searchLoading,
    results: state.searchResults,
    categories: state.categories,
    currentCategory: state.category,
  };
};

export default connect(mapStateToProps)(SearchFilters);
